import Backdraft from "backdraft-app/src/backdraft";
import _ from "underscore";

import KeywordsOwner from "shared/keywords_form/models/keywords_owner";

Backdraft.app("Shared/SignalExpression", function(app) {
  var PHRASE_MATCH    = "(.*?)";
  var SPEAKER_MATCH   = "\\(([^)]*)\\)";
  var SEPARATOR_REGEX = "\\s";
  var KEYWORD_NAME_REGEX = /^[A-Za-z'’\s]+$/;

  var phraseAndSpeakerRegex = new RegExp(PHRASE_MATCH + "(?:" + SEPARATOR_REGEX + SPEAKER_MATCH + "|$)");

  // assign the owner interface class into the current app's Model namespace
  app.Models.KeywordsOwner = KeywordsOwner;

  app.model("VoiceKeyword", "KeywordsOwner", {
    // convert data from boolean expression JSON format to local app
    parse: function(attrs, options) {
      var data = {};

      data.any_or_all = this._parsePhraseMatchTypeForView(attrs.phrase_match_type);
      if (data.any_or_all === "any") {
        data.uniq_phrase_said_count = attrs.phrase_count;
      } else {
        data.total_phrase_said_count = attrs.phrase_count;
      }

      // convert to collection
      if (attrs.phrase_array) {
        var keywords  = _.map(attrs.phrase_array, function(phrase) {
          const phraseData = phrase.match(phraseAndSpeakerRegex);
          const name        = phraseData[1];
          const speaker     = phraseData[2] ? this._capitalized(phraseData[2]) : this.defaultSpeaker;

          return { name: name, speaker: speaker };
        }.bind(this));
        this.keywords.reset(keywords);
      }

      return data;
    },

    toJSON: function() {
      var json = {
        phrase_match_type: this._phraseMatchType(),
        phrase_count:      this._phraseCount(),
        phrase_array:      _.compact(this.keywords.invoke("phraseWithSpeaker"))
      };

      return json;
    },

    validate: function(attrs, options) {
      var errors = app.Models.VoiceKeyword.__super__.validate.call(this, attrs, options) || {};

      if (this._phrasesContainSpecialCharacters()) {
        errors.keywords = "Phrases cannot contain digits or special characters";
      }

      return !_.isEmpty(errors) ? errors : null;
    },

    toExpressionText: function() {
      return this._phraseMatchType() + "(" + (this._phraseCount()) + ", [" + this.keywords.invoke("phraseWithSpeakerAsText").join(", ") + "])";
    },

    isRequired: function(features) {
      return (
        !features.rules &&

        (
          (features.voice && features.api && this._hasPhrases()) ||
          (features.voice && !features.api)
        )
      );
    },

    _hasPhrases: function() {
      return this.keywords.stats().unique.length > 0;
    },

    _phraseMatchType: function() {
      if (this.get("any_or_all") === "all" || this.get("any_or_all") === "all_repeated") {
        return "all_repeated";
      } else {
        return "any";
      }
    },

    _parsePhraseMatchTypeForView: function(matchType) {
      if (matchType === "all" || matchType === "all_repeated") {
        return "all";
      } else {
        return "any";
      }
    },

    _capitalized: function(val) {
      return val.substring(0, 1).toUpperCase() + val.substring(1).toLowerCase();
    },

    _phrasesContainSpecialCharacters: function() {
      return (
        this.keywords.some(function(keyword) {
          if (keyword.get("name")) {
            if (keyword.get("name").match(KEYWORD_NAME_REGEX)) {
              return keyword.get("name").match(KEYWORD_NAME_REGEX)[0].length !== keyword.get("name").length;
            } else {
              return true;
            }
          }
        })
      );
    }
  });
});
